<template>
	<div class="lane-closure-filters lane-closure-filters-mobile" :class="{'fixed-header-active': (showMessages || showUpdates || showAdvancedSearch)}">
		<div class="alerts" :class="{'expandedPanels':showMessages || showUpdates || showAdvancedSearch}">
			<div @click="toggleMessages" class="options" :class="{ activeOption: showMessages === true}">
				<img v-if="unreadMessagesCount > 0" src="@/assets/lc-header-messages-active.svg" alt="Messages" />
				<img v-if="unreadMessagesCount == 0" src="@/assets/lc-header-messages.svg" alt="Messages" />
				<span v-html="getMessageTitle()">{{messageNotificationsCount ? messageNotificationsCount : ''}} Messages</span>
			</div>
			<div @click="toggleUpdates" class="options" :class="{ activeOption: showUpdates === true}">
				<img v-if="unreadUpdatesCount == 0" src="@/assets/lc-header-updates.svg" />
				<img v-if="unreadUpdatesCount > 0" src="/img/nav/icon-bell-circle-inverse.svg" />
				<span v-html="getUpdateTitle()">{{updateNotificationsCount ? updateNotificationsCount : ''}} Updates</span>
			</div>
			<div @click="toggleAdvancedSearch" class="options"  :class="{ activeOption: showAdvancedSearch === true}">
				<img v-if="!hasAdvancedFilters() && !showAdvancedSearch" src="@/assets/lc-header-filter.svg" />
				<img v-if="hasAdvancedFilters() || showAdvancedSearch" src="/img/nav/icon-filter-dark-reverse.svg" />
				<span>
					<span v-if="advancedFilterCount()">{{advancedFilterCount()}} </span>
					<span :class="{'pl-0' : advancedFilterCount() > 0}" v-if="!advancedFilterCount() || advancedFilterCount() == 1">Filter</span>
					<span class="pl-0" v-else>Filters</span>
				</span>
			</div>

			<div @click="toggleMenu" class="options">
				<b-img src="/img/lcr-quick-nav/menuicon.svg" alt="menu" />
				<span>
					<span class="pl-0">Menu</span>
				</span>
			</div>

		</div>
		<b-row class="mobile-only flex header-filter">
			<!-- <b-col class="search-bar-col-mobile" cols="9" md="11" hidden> -->
			<b-col class="search-bar-col-mobile d-flex" cols="12" md="12">
				<div class="search-query w-50">
					<label>SEARCH</label>
					<b-input-group>
						<b-form-input class="input-search" placeholder="Search..." v-model="globalSearch" v-on:keyup.enter="searchGlobal" />
						<b-input-group-append class="vdp-datepicker__search-button">
							<button type="button" class="btn" @click="searchGlobal()"><i class="icon-search"></i></button>
						</b-input-group-append>
						<!-- <b-input-group-append class="vdp-datepicker__clear-button" v-if="globalSearch" @click="clearSearch()">
							<b-input-group-text>
								&times;
							</b-input-group-text>
						</b-input-group-append> -->
					</b-input-group>
				</div>
				<div class="w-50 header-datepicker">
					<label>DATE</label>
					<b-input-group>
						<b-input-group-append class="vdp-datepicker__search-button">
							<date-range-picker @toggle="handleCalendarState" v-model="filterDate" show-dropdowns opens="center" @update="onDateRangeSelect" :ranges="dateRangePickerRanges" :auto-apply="true" :append-to-body="true">
								<template v-slot:input="picker" style="min-width: 350px;">
									<span v-if="picker.startDate && picker.endDate" v-html="formatDateRange(picker.startDate,picker.endDate)">
									</span>
									<span v-else>Start/End Date</span>
								</template>
							</date-range-picker>
						</b-input-group-append>
					</b-input-group>
				</div>
				<!-- <div @click="clearSearch()" class="reset-filter">
					<img src="@/assets/lc-filter-reset.svg" height="30px"/>
				</div> -->
			</b-col>
			<!-- <b-col>
				<div id="advance-search-filter-mobile" @click="toggleAdvancedSearch">
				<img src="../assets/filtericon.svg" alt="filter" /> Filters <img src="../assets/downarrow.svg" alt="downarrow" :class="{'advance-arrow': true, 'mobile': true, 'up': showAdvancedSearch}" />
				</div>
			</b-col> -->
		</b-row>

		<!--<div class="search-row-mobile" id="search-row">
			<div class="search-row__full-total-mobile" v-for="(task, index) in Totals" :key="'index'+index">
				<a v-for="(item, i) in task.status" :key="'i'+i" href="#"
					@click="$emit('update:status', index, item.name)"
					v-show="activeList === index && callOptionMethod"
					:class="activeList === index && activeTabName === item.name ? 'active':'inactive'"
				>
					<span class="lc-total-badge" v-text="item.count"></span> {{ item.name | capitalize }}
				</a>
				<a href="#" class="reload" v-show="activeList === index && callOptionMethod">
					<img src="@/assets/lc-reload.svg" height="30px"/>
				</a>
			</div>
			<div class="search-row__filter-button">
				<div id="advance-search-filter" @click="toggleAdvancedSearch">
					<img src="../assets/filtericon.svg" alt="filter" /> FILTERS <span class="badge badge-secondary" v-if="hasAdvancedFilters()" v-html="advancedFilterCount()"></span> <img src="../assets/downarrow.svg" alt="downarrow"
						:class="{'advance-arrow': true, 'up': showAdvancedSearch}" />
				</div>
			</div>
		</div>-->
		<div class="quick-switch-container-wrapper quick-switch-container-wrapper-mobile d-none">
			<div class="quick-switch-container container wide" v-if="storeModule == 'reportContraventionList' &&  !showNewContraventionButton">
				<div class="quick-switch">
					<div class="quick-switch__contraventions-title">Violations</div>
				</div>
			</div>
			<div class="quick-switch-container container wide" v-if=" (storeModule == 'reportContraventionList' && showNewContraventionButton) || storeModule != 'reportContraventionList'">
				<div class="quick-switch">
					<div class="quick-switch__title" v-html="title"></div>
					<div class="quick-switch__full-total" v-for="(task, index) in Totals" :key="'index'+index">
						<div class="quick-switch__item-total lane-column" :class="{ 'blue-background': activeList === index }">
							<caption class="badge-title" style="white-space:nowrap" @click="$emit('update:status', index)">
								<span :style="{ 'order': activeList === index ? '2' : 'initial' }">&nbsp;{{ task.taskTitle }}&nbsp;</span>
								<b-badge>{{ task.total }}</b-badge>
							</caption>
							<b-button style="white-space:nowrap" v-for="(item, i) in task.status" :key="'i'+i" @click="$emit('update:status', index, item.name)" v-show="activeList === index && callOptionMethod" :class="activeList === index && activeTabName === item.name ? 'active':'inactive'">
								{{ item.name | capitalize }} <b-badge v-text="item.count"></b-badge>
							</b-button>
							<button v-show="activeList === index && callOptionMethod" class="quick-switch__refresh-quick-switch btn" @click="$emit('update:refresh')">
								<img src="/img/nav/icon-refresh-quick-switcher.svg" alt="filter" />
							</button>
						</div>
					</div>
					<button v-if="showPrintPdf" class="quick-switch__action-button quick-switch__action-button--download btn btn-secondary" @click="$emit('submit:printpdf')" :disabled="printing">
						<slot v-if="printing">
							<b-spinner small label="Saving..." class="ml-2" v-if="printing"></b-spinner>
						</slot>
						<slot v-else>
							<font-awesome-icon icon="print" />
						</slot>
					</button>
				</div>
			</div>
		</div>
		<transition name="slide-down" tag="div">
			<div id="advance-search"  :class="{'advance-search-wrapper':true,'expanded': showAdvancedSearch}" v-show="showAdvancedSearch">
				<div id="advance-search-expandable">
					<div class="d-flex advance-search--blue-fields">
						<div class="advance-search--filter-status"
											v-for="(column, index) in statusColumns"
											:key="'il'+index"
											:class="column.widths + ' col__' + column.key"
										>
						<div class="column-title">
							<b-form-group
									label="Status"
									label-size="sm"
									label-cols="col"
									content-cols="col"
									label-for="fs-filter-status"
							>
								<b-form-select ref="filterRecordStatusId" v-if="column.key == 'status'" :options="LaneClosureRequest.getFilterLaneClosureRequestRecordStatusIdOptionsMobile"
								id="fs-filter-status"
								v-model="filterRecordStatusId.value"
								@input="onFilterRecordStatusId"
								:state="filterRecordStatusId.status"
								value-field="id"
								text-field="name"
								class="filter-record-status-id"
								size="sm"
								>
								</b-form-select>
							</b-form-group>
						</div>
						</div>
						<div class="advance-search--sort-by"
						style="padding-left:5px;" :class="showPrintPdf ? ['quick-switch__sort-by'] : ['quick-switch__sort-by','no-border']">
							<b-form-group
									label="Sort"
									label-size="sm"
									label-cols="col"
									content-cols="col"
									label-for="fs-filter-sort-by"
							>
									<b-form-select
											id="fs-filter-sort-by"
											size="sm"
											:options="LaneClosureRequest.getSortOptions"
											@input="sortByChange"
											:state="filterSortBy.status"
											v-model="filterSortBy.value"
									/>
							</b-form-group>
						</div>
					</div>

					<div class="advance-search--other-fields">
						<b-row>
						<b-col lg>
							<b-form-group label="" class="form-group--filter-mine" :state="filterMine.status" :invalid-feedback="filterMine.invalidMessage">
								<b-form-checkbox :checked="filterMine.value == 1" v-model="filterMineModel" key="filterMine" :unchecked-value="0" :value="1" name="filterMine"><span>Show My Requests</span></b-form-checkbox>
								</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<template v-for="(column, i) in columns">
							<b-col lg v-if="column.key !== 'requesterProjectName' && column.key !== 'date'" :key="'i2'+i" v-show="column.filter && column.filter.show" :class="getAdvanceSearchColumnClasses(column.key)">
								<b-form-group :label="((column.alternateLabel ? column.alternateLabel : column.label) + (column.key === 'date' ? ' [mm/dd/yyyy]' : '')) | capitalize" label-size="sm" label-for="input-date-of-project">
									<!-- IMPORTANT: Trigger to force update auto-complete component -->
									<!-- <marker v-if="column.filter && column.filter.autoComplete">{{ getArgValues(column.filter.key, column.filter.autoComplete.label) }}</marker> -->
									<slot v-if="column.key === 'date'">
										<date-range-picker v-model="filterDate" show-dropdowns opens="center" @update="onDateRangeSelect" :ranges="dateRangePickerRanges" :auto-apply="true" :append-to-body="true" />
									</slot>
									<slot v-else-if="column.filter && column.filter.autoComplete && column.key === 'requesterProjectName'">
										<multiselect class="custom-multiselect" ref="requesterProjectFilter" v-model="arg[column.filter.key]" track-by="id" open-direction="bottom" label="label" :options="requesterProjectOptions" :show-labels="false" :multiple="false" :close-on-select="true" :hide-selected="false" :preserve-search="false" :clear-on-select="true" :internal-search="false" placeholder="Select or start typing" :loading="isRequesterProjectLoading" @search-change="onRequesterProjectSearch" :preselect-first="true" @select="onRequesterProjectInput(column.filter.key)" @input="onRequesterProjectInput(column.filter.key)" @blur="onRequesterProjectInput(column.filter.key)" @keydown.tab="onRequesterProjectInput(column.filter.key)">
											<template slot="selection" slot-scope="{ values, search, isOpen }">
												<span class="multiselect__single" v-if="values.length && !isOpen" v-html="getOptionSelected(values.length)"></span>
											</template>
											<template slot="option" slot-scope="props">
												<div class="option__desc">
													<span class="option__title">{{ props.option.label }}</span><br>
												</div>
											</template>
											<template slot="noOptions">
											</template>
											<template slot="afterList">
												<li class="multiselect__after-list">Start typing to find projects.</li>
											</template>
											<template slot="noResult">
												No results. Please try changing the search query.
											</template>
										</multiselect>
										<!-- <treeselect
										:multiple="false"
										:async="true"
										:limit="1"
										:clearable="true"
										:load-options="loadOptions1"
										:placeholder="'Find '+(column.alternateLabel ? column.alternateLabel : column.label) | capitalize"
										v-model="arg[column.filter.key]"
										@input="handleAutocomplete"
									>
										<div slot="value-label" slot-scope="{ node }">{{ parseLabel(node, column.filter.key+'_label') }}</div>
									</treeselect> -->
									</slot>
									<slot v-else-if="column.filter && column.filter.autoComplete && column.key === 'affectedStreet'">
										<multiselect class="custom-multiselect" ref="affectedStreetFilter" v-model="arg[column.filter.key]" track-by="id" open-direction="bottom" label="label" :options="affectedStreetOptions" :show-labels="false" :multiple="false" :close-on-select="true" :hide-selected="false" :preserve-search="false" :clear-on-select="false" :internal-search="false" placeholder="Select or start typing" :loading="isAffectedStreetsLoading" @search-change="onAffectedStreetSearch" @select="onAffectedStreetInput">
											<template slot="selection" slot-scope="{ values, search, isOpen }">
												<span class="multiselect__single" v-if="values.length && !isOpen" v-html="getOptionSelected(values.length)"></span>
											</template>
											<template slot="option" slot-scope="props">
												<div class="option__desc">
													<span class="option__title">{{ props.option.label }}</span><br>
												</div>
											</template>
											<template slot="noOptions">
											</template>
											<template slot="afterList">
												<li class="multiselect__after-list">Start typing to find streets.</li>
											</template>
											<template slot="noResult">
												No results. Please try changing the search query.
											</template>
										</multiselect>
										<treeselect openDirection="above" :maxHeight="120" :multiple="false" :async="true" :limit="1" :clearable="true" :load-options="loadOptions2" :placeholder="'Find '+(column.alternateLabel ? column.alternateLabel : column.label) | capitalize" v-model="arg[column.filter.key]" v-if="1==2">
											<div slot="value-label" slot-scope="{ node }">{{ parseLabel(node, column.filter.key+'_label') }}</div>
										</treeselect>
									</slot>
									<!-- v-model="arg[column.filter.key]['arg'][column.filter.autoComplete.label]"
									<input-auto-complete v-if="column.filter && column.filter.autoComplete"
										:action="column.filter.autoComplete.search"
										:selection.sync="arg[column.filter.key] && arg[column.filter.key][column.filter.autoComplete.label]"
										:keyField="column.filter.key"
										:label="column.filter.autoComplete.label"
										:name="column.filter.autoComplete.name"
										:placeholder="'Find '+(column.alternateLabel ? column.alternateLabel : column.label) | capitalize"
										v-on:on:submit="onAutoCompleteSubmit"
									/> -->
								</b-form-group>
							</b-col>
						</template>
						<b-col lg>
								<b-form-group
									label="Organization"
									label-size="sm"
									label-for="fs-filter-org"
								>
									<treeselect
										v-model="filterOrganization.value"
										openDirection="below"
										placeholder="Select Organization"
										@input="onOrganizationInput"
										:multiple="false"
										:options="organizations"
										:clearable="true"
										:maxHeight="120"
									>
									</treeselect>
								</b-form-group>
							</b-col>
						<b-col lg>
							<b-form-group label="Peak Time" label-size="sm" label-for="fs-filter-peak-type">
								<b-form-select id="fs-filter-peak-type" v-model="filterPeakTime.value" :options="LaneClosureRequest.getPeakTimeFilterOptions" @input="filterPeakTime.resetStatus()" :state="filterPeakTime.status" value-field="id" text-field="name" @change="togglePeakTime"></b-form-select>
							</b-form-group>
						</b-col>
						<b-col lg>
							<b-form-group label="Closure Type" label-size="sm" label-for="fs-filter-closure-type">
								<b-form-select id="fs-filter-closure-type" v-model="filterClosureType.value" :options="LaneClosureRequest.getClosureTypeFilterOptions" @input="filterClosureType.resetStatus()" :state="filterClosureType.status" value-field="id" text-field="name" @change="toggleClosureType"></b-form-select>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<template v-for="(column, i) in columns">
							<b-col lg v-if="column.key === 'requesterProjectName'" :key="'i2'+i" v-show="column.filter && column.filter.show" :class="getAdvanceSearchColumnClasses(column.key)">
								<b-form-group :label="((column.alternateLabel ? column.alternateLabel : column.label) + (column.key === 'date' ? ' [mm/dd/yyyy]' : '')) | capitalize" label-size="sm" label-for="input-date-of-project">
									<slot v-if="column.filter && column.filter.autoComplete && column.key === 'requesterProjectName'">
										<multiselect class="custom-multiselect" ref="requesterProjectFilter" v-model="arg[column.filter.key]" track-by="id" open-direction="bottom" label="label" :options="requesterProjectOptions" :show-labels="false" :multiple="false" :close-on-select="true" :hide-selected="false" :preserve-search="false" :clear-on-select="true" :internal-search="false" placeholder="Select or start typing" :loading="isRequesterProjectLoading" @search-change="onRequesterProjectSearch" :preselect-first="true" @select="onRequesterProjectInput(column.filter.key)" @input="onRequesterProjectInput(column.filter.key)" @blur="onRequesterProjectInput(column.filter.key)" @keydown.tab="onRequesterProjectInput(column.filter.key)">
											<template slot="selection" slot-scope="{ values, search, isOpen }">
												<span class="multiselect__single" v-if="values.length && !isOpen" v-html="getOptionSelected(values.length)"></span>
											</template>
											<template slot="option" slot-scope="props">
												<div class="option__desc">
													<span class="option__title">{{ props.option.label }}</span><br>
												</div>
											</template>
											<template slot="noOptions">
											</template>
											<template slot="afterList">
												<li class="multiselect__after-list">Start typing to find projects.</li>
											</template>
											<template slot="noResult">
												No results. Please try changing the search query.
											</template>
										</multiselect>
										<!-- <treeselect
										:multiple="false"
										:async="true"
										:limit="1"
										:clearable="true"
										:load-options="loadOptions1"
										:placeholder="'Find '+(column.alternateLabel ? column.alternateLabel : column.label) | capitalize"
										v-model="arg[column.filter.key]"
										@input="handleAutocomplete"
									>
										<div slot="value-label" slot-scope="{ node }">{{ parseLabel(node, column.filter.key+'_label') }}</div>
									</treeselect> -->
									</slot>
								</b-form-group>
							</b-col>
						</template>
						<b-col lg>
							<b-form-group label="Completion" label-size="sm" label-for="fs-filter-completed-request">
								<b-form-select id="fs-filter-completed-request" v-model="filterCompleted.value" :options="LaneClosureRequest.getLaneClosureCompletionOptions" @input="filterCompleted.resetStatus()" :state="filterCompleted.status" value-field="id" text-field="name" @change="toggleCompleted"></b-form-select>
							</b-form-group>
						</b-col>
						<b-col id="search-col">
							<!-- <b-button id="search-btn" size="sm" @click="$emit('submit:filters')">Search</b-button> -->
							<div class="d-flex pl-3">
								<b-button id="search-btn" size="sm" @click="setArgs" class="mr-2 mb-2">Search</b-button>
							<b-button class="mb-2" variant="danger" id="reset-filter" @click="resetArgs" v-if="hasAdvancedFilters()">Reset</b-button>
							</div>
						</b-col>
					</b-row>
					<div @click="swipeUpHandler" class="close-panels">
						<img src="@/assets/lc-close.svg" />
					</div>
				</div>
	</div>
	</div>
</transition>
		<transition name="slide-down" tag="div">

			<div class="updates-slide-panel" v-show="showUpdates">
				<div>
		<div :class="{'expandedUpdates': showUpdates}" class="notification-entry updates-wrapper row">
			<b-collapse :visible="showUpdates" id="updates-expandable">
				<div class="updates-wrapper-header" v-if="updateNotifications.length >= 1">
					<span class="updates-wrapper-header-title">Updates</span> <b-badge v-show="updateNotificationsCount > 0">{{updateNotificationsCount}}</b-badge>
					<router-link v-if="false" class="btn text-primary btn-sm btn-text float-right btn-notification-settings" to="/my-notifications"><span>Settings</span></router-link>
					<b-link class="btn text-primary btn-sm btn-text float-right btn-notification-settings" @click="clearAllClick('updates')"><span>Mark All Read</span></b-link>

				</div>
				<div class="updates-wrapper-body">
				<b-row v-for="(entry, i) in updateNotifications" :key="i">
					<b-col cols="1">
						<svg width="10" height="10">
							<circle cx="5" cy="5" r="5" :fill="getNotificationBubbleColor(entry)" />
						</svg>
					</b-col>
					<b-col @click="goToNotificationDest(entry)">
						<p>{{entry.messageTitle}}</p>
						<h6 v-html="entry.message"></h6>
						<p>{{moment(entry.notificationDate).fromNow()}}</p>
					</b-col>
				</b-row>
				<b-row v-if="updateNotifications.length < 1">
					<b-col>
						<p>No Unread Updates</p>
					</b-col>
				</b-row>
				<div @click="swipeUpHandler" class="close-panels">
					<img src="@/assets/lc-close.svg" />
				</div>
				</div>
			</b-collapse>
		</div>
	</div></div>
	</transition>
			<transition name="slide-down" tag="div">
		<div class="updates-slide-panel" v-show="showMessages">
			<div>
		<b-row :class="{'expandedMessages': showMessages}" class="notification-entry messages-wrapper">
			<b-collapse :visible="showMessages" id="messages-expandable">
				<div class="messages-wrapper-header" v-if="messageNotifications.length > 0">
				<span class="messages-wrapper-header-title">Messages</span><b-badge v-show="messageNotificationsCount > 0">{{messageNotificationsCount}}</b-badge>
				<router-link v-if="false" class="btn text-primary btn-sm btn-text float-right btn-notification-settings" to="/my-notifications"><span>Settings</span></router-link>
				<b-link class="btn text-primary btn-sm btn-text float-right btn-notification-settings" @click="clearAllClick('messages')"><span>Mark All Read</span></b-link>
				</div>
				<div class="messages-wrapper-body">
				<b-row v-for="(entry, i) in messageNotifications" :key="i">
					<b-col cols="1">
						<svg width="10" height="10">
							<circle cx="5" cy="5" r="5" :fill="getNotificationBubbleColor(entry)" />
						</svg>
					</b-col>
					<b-col @click="goToNotificationDest(entry)">
						<p class="m-0">{{entry.messageTitle}}</p>
						<strong v-html="entry.message"></strong>
						<p>{{moment(entry.notificationDate).fromNow()}}</p>
					</b-col>
				</b-row>
				<b-row v-if="messageNotifications.length < 1">
					<b-col>
						<p>No New Messages</p>
					</b-col>
				</b-row>
				<div @click="swipeUpHandler" class="close-panels">
					<img src="@/assets/lc-close.svg" />
				</div>
				</div>
			</b-collapse>
		</b-row>
	</div>
</div>
		</transition>
		<div v-if="false" class="lane-closure-filters__title" :class="getFilterTitleClasses()">{{title}}</div>
	<div class="calendar--backdrop" v-if="calendarBackdrop"></div>
	</div>
</template>
<script>
import Vue from 'vue'
import treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect'
// import InputAutoComplete from './../components/_input-auto-complete'
import LaneClosureRequest from './../models/LaneClosureRequest'
import BootstrapField from './../utility/BootstrapField';
import Format from './../utility/Format';
import moment from 'moment-timezone';


export default {
	name: 'LaneFilters',
	components: {
		treeselect,
		// 'input-auto-complete': InputAutoComplete
	},
	props: {
		columns: Array,
		totals: Object,
		activeList: Number,
		activeTabName: String,
		callOptionMethod: String,
		unreadMessagesCount: Number,
		unreadUpdatesCount: Number,
		title: String,
		printing: Boolean,
		storeArgs: String,
		storeModule: String,
		showEmergencyClosureButton: Boolean,
		showEmergencyRestrictionButton: Boolean,
		showNewContraventionButton: Boolean,
		canCreateContravention: Boolean,
		showPrintPdf: Boolean,
	},
	data: () => ({
		calendarBackdrop: false,
		messageNotifications: [],
		updateNotifications: [],
		messageNotificationsCount: 0,
		updateNotificationsCount: 0,
		showAdvancedSearch: false,
		showMessages: false,
		showUpdates: false,
		showLaneFilter: false,
		filterMineModel:false,
		arg: {},
		organizations: [],
		filterOrganization: new BootstrapField({
			value: null,
		}),
		filterCompleted: new BootstrapField({
			value: 0,
		}),
		filterRecordStatusId: new BootstrapField({
			value: null,
		}),
		filterClosureType: new BootstrapField({
			value: null,
		}),
		filterPeakTime: new BootstrapField({
			value: null,
		}),
		filterMine: new BootstrapField({
			value: 1,
		}),
		globalSearch: null,
		isAffectedStreetsLoading: false,
		isRequesterProjectLoading: false,
		affectedStreetOptions: [{
			id: null,
			label: "Any Street",
		}],
		requesterProjectOptions: [{
			id: null,
			label: "Any Project",
		}],
		LaneClosureRequest,
		filterDate: {
			startDate: null,
			endDate: null,
		},
		filterSortBy: new BootstrapField({
			value: '',
		}),

	}),
	created() {
		this.getOrganizationsForTreeSelect();
	},
	mounted() {
		this.getUnreadNotifications();
		this.getAdvancedSearch();

		if (this.columns) {
			this.columns.forEach(item => {
				if (item.filter) {
					// if ( item.filter.autoComplete && item.filter.show ) {
					this.getArgs(item.filter)
					// }
				}
			})
		}
		Vue.prototype.$bus.$off("filter:showMineApplied", this.setShowMineApplied);	
		Vue.prototype.$bus.$on("filter:showMineApplied", this.setShowMineApplied);

	},
	watch: {
		'unreadMessagesCount': function() {
			let that = this;
			that.messageNotifications = that.$store.getters['notificationList/messages'];
			that.updateNotifications = that.$store.getters['notificationList/updates'];
			that.messageNotificationsCount = that.$store.getters['notificationList/unreadMessagesCount'];
			that.updateNotificationsCount = that.$store.getters['notificationList/unreadUpdatesCount'];
			Vue.prototype.$bus.$emit("notification:refresh");
		},
		'arg': function() {
			localStorage.setItem(this.storeArgs, JSON.stringify(this.arg))
		},
			'filterMineModel':function() {
				this.filterMine.value = this.filterMineModel;
				this.arg['showMine'] = this.filterMine.value;
				Vue.prototype.$bus.$emit("filter:setShowMine", this.filterMine.value);
			},
		'globalSearch': function() {
			this.arg['keywords'] = this.globalSearch;
			localStorage.setItem(this.storeArgs, JSON.stringify(this.arg))
			this.$emit('update:filters');
		},
		'isLoggedIn': function() {
			if (this.isLoggedIn) {
				this.getUnreadNotifications();
			}
		}
	},
	computed: {

		statusColumns: function() {
			return this.columns.filter(item => {
				if (item.key == 'status') {
					return item;
				}
			});
		},


		isLoggedIn: function() {
			return this.$store.getters.isLoggedIn
		},
		Totals() {
			let lists = [];
			let showOnlyModule = null;
			let taskTitle = "Requests";
			if (this.storeModule == "reportContraventionList") {
				showOnlyModule = "contraventions";
			}
			if (this.storeModule == "reportClosureList") {
				showOnlyModule = "closures";
			}
			if (this.storeModule == "reportRestrictionList") {
				showOnlyModule = "restrictions";
			}

			if (showOnlyModule != null) {
				for (let item in this.totals) {
					if (item == showOnlyModule) {
						let attr = [],
							total = 0
						for (let key in this.totals[item]) {
							attr.push({
								name: key,
								count: parseInt(this.totals[item][key])
							})
							total += parseInt(this.totals[item][key])
						}
						taskTitle = "Requests";

						if (item == "contraventions") {
							taskTitle = "Requests";
						}
						if (item == "closures") {
							taskTitle = "Closures";

						}
						if (item == "restrictions") {
							taskTitle = "Restrictions";
						}
						lists.push({
							taskName: item,
							taskTitle: taskTitle,
							total,
							status: attr
						})
					}
				}

			} else {
				// show all modules except contraventions
				for (let item in this.totals) {
					if (item != "contraventions") {
						let attr = [],
							total = 0
						for (let key in this.totals[item]) {
							attr.push({
								name: key,
								count: parseInt(this.totals[item][key])
							})
							total += parseInt(this.totals[item][key])
						}
						taskTitle = "Requests";
						if (item == "contraventions") {
							taskTitle = "Violations";
						}
						if (item == "closures") {
							taskTitle = "Closures";

						}
						if (item == "restrictions") {
							taskTitle = "Restrictions";
						}
						lists.push({
							taskName: item,
							taskTitle: taskTitle,
							total,
							status: attr
						})
					}
				}
			}
			return lists
		},

		dateRangePickerRanges() {
			return Format.getLocalDatePickerRanges();
		}
	},
	methods: {
		handleCalendarState(currentState) {
			if(this.$store.state.isMobile) {
				this.calendarBackdrop = currentState
			} else {
				this.calendarBackdrop = false
			}
		},
		getFilterTitleClasses() {
			if (this.title == "All Expired Requests Without Violations") {
				return "lane-closure-filters__title-small";
			}
			return null;
		},

		clearAllClick(type) {
			if (type == "messages") {
				this.$store.dispatch('notificationList/dismissAllMessageNotification', type)
				.then(() => {
					this.messageNotifications = this.$store.getters['notificationList/messages'];
					this.updateNotifications = this.$store.getters['notificationList/updates'];
					this.messageNotificationsCount = this.$store.getters['notificationList/unreadMessagesCount'];
					this.updateNotificationsCount = this.$store.getters['notificationList/unreadUpdatesCount'];
					Vue.prototype.$bus.$emit("notification:refresh");
				});
			} else {
				this.$store.dispatch('notificationList/dismissAllUpdateNotification', type)
				.then(() => {
					this.messageNotifications = this.$store.getters['notificationList/messages'];
					this.updateNotifications = this.$store.getters['notificationList/updates'];
					this.messageNotificationsCount = this.$store.getters['notificationList/unreadMessagesCount'];
					this.updateNotificationsCount = this.$store.getters['notificationList/unreadUpdatesCount'];
					Vue.prototype.$bus.$emit("notification:refresh");
				});
			}
		},
		getMessageTitle() {
			if (this.unreadMessagesCount == 1) {
				return "1 Message";
			} else {
				return this.unreadMessagesCount + " Messages";
			}
		},		
		getUpdateTitle() {
			if (this.unreadUpdatesCount == 1) {
				return "1 Update";
			} else {
				return this.unreadUpdatesCount + " Updates";
			}
		},
		onFilterRecordStatusId() {
			this.$store.dispatch(this.storeModule+'/updateParams', { recordStatusId: this.filterRecordStatusId.value} )
			/*
			Vue.prototype.$bus.$emit("filter:fetchData")
			*/
		},
		onColumnChevronToggle(e, toggle = null) {
			e.preventDefault()
			if ( e.target.getAttribute('data-key') ) {
				// if ( this.$store.getters[this.storeModule+'/getParams'].sortBy !== e.target.getAttribute('data-key') ) {
				// 	this.$store.dispatch(this.storeModule+'/updateParams', { sortBy: e.target.getAttribute('data-key') } )
				// }
				// this.ascOrder = !this.ascOrder
				// this.ascOrder ? e.target.classList.add('asort') : e.target.classList.remove('asort')
				// this.$store.dispatch(this.storeModule+'/updateParams', { sortOrder: this.ascOrder ? 'asc' : 'desc' } )
				// this.fetchData()

				var dbKey = e.target.getAttribute('data-key');

				if (this.$store.getters[this.storeModule+'/getParams'].sortBy !== dbKey) {
					this.$store.dispatch(this.storeModule+'/updateParams', { sortBy: dbKey, sortOrder: 'asc' });
				} else {
					this.$store.dispatch(this.storeModule+'/updateParams', { sortOrder: this.$store.getters[this.storeModule+'/getParams'].sortOrder == 'asc' ? 'desc' : 'asc' });
				}
				this.$refs.filterRef.changeSortFromColumn(dbKey, this.$store.getters[this.storeModule+'/getParams'].sortOrder);

			} else {
				Vue.prototype.$bus.$emit("map:toggle", e, toggle)
			}
		},
		showSortArrow(column, order) {
			let sortBy = this.$store.getters[this.storeModule+"/getParams"].sortBy;
			let sortOrder = this.$store.getters[this.storeModule+"/getParams"].sortOrder;

			var dbKey = column.key;

			if (order == '' || order == null) {
				return dbKey != sortBy
			} else {
				return dbKey == sortBy && sortOrder == order
			}

		},
		sortByChange() {
			let val = this.filterSortBy.value;
				if (val) {
						let vals = val.split(" ");
						this.arg['sortBy'] = vals[0];
						this.arg['sortOrder'] = vals[1];
				}
				else {
						this.arg['sortBy'] = this.arg['sortOrder'] = null;
				}
				// this.setArgs();
				// this.$emit("submit:filters");
		},
		swipeUpHandler() {
			this.showAdvancedSearch = false;
			this.showMessages = false;
			this.showUpdates = false;
		},
		getNotificationBubbleColor(entry) {
			if (entry.readDate || entry.isRead == 1) {
				return '#eeeeee';
			} else {
				return '#293c7c';
			}
		},
		goToNotificationDest(notification) {
			if (notification.lcrId) {
				if (notification.notificationTypeId == 'new-contravention') {
					this.$router.push(`/lane-closure-request/${notification.lcrId}/view-contravention/${notification.entityId}`);
				} else if ( notification.notificationTypeId == 'contravention-new-message') {
					this.$router.push(`/lane-closure-request/${notification.lcrId}/view-contravention/${notification.contraventionId}`);
				} else {
					this.$router.push(`/lane-closure-request/${notification.lcrId}/view`);
				}
			}

			this.showNotifications = false;
		},
		showNotification(entry) {
			if (['lcr-new-message', 'lcr-change-request', 'contravention-new-message'].includes(entry.notificationTypeId)) {
				this.messageNotifications.unshift(entry);
				if (entry.isRead == 0 && !entry.readDate) this.messageNotificationsCount++;
			} else {
				this.updateNotifications.unshift(entry);
				if (entry.isRead == 0 && !entry.readDate) this.updateNotificationsCount++;
			}
		},
		getUnreadNotifications() {
			let that = this;
			this.$store.dispatch('notificationList/load').then(() => {
				that.messageNotifications = that.$store.getters['notificationList/messages'];
				that.updateNotifications = that.$store.getters['notificationList/updates'];
				that.messageNotificationsCount = that.$store.getters['notificationList/unreadMessagesCount'];
				that.updateNotificationsCount = that.$store.getters['notificationList/unreadUpdatesCount'];
				Vue.prototype.$bus.$emit("notification:refresh");
			});
		},
		formatDateRange(startDate, endDate) {
			let sd = this.$moment(startDate);
			let ed = this.$moment(endDate);
			return sd.format('MM/DD/YYYY') + " - " + ed.format('MM/DD/YYYY');
		},

		hasAdvancedFilters() {
					if (this.$store.getters.userInfo() == null) {
							return false;
					}
			for (let item in this.arg) {
							if (this.arg[item] != null ) {
								if (item != "completed" && item != "keywords" && item != "closureType" && item != "peakTime"
									&& item != "fromDateTime" && item != "toDateTime" && item != "sortBy" && item != "sortOrder"
									&& item != "showMine" && item != "RequesterOrganizationId"
				) {
					if (item == "requesterProjectId") {
						if (this.arg[item].id != null) {
							return true;
						}
					} else {
								return true;
							}
						}
					}
						}
			if (this.filterCompleted.value !== 0) {
				return true;
			}
			if (this.filterClosureType.value !== null) {
				return true;
			}
			// if (this.filterMine.value !== this.$store.getters.userInfo().showMine) {
			// 	return true;
			// }
			if (this.filterOrganization.value !== null && this.filterOrganization.value !== undefined) {
				return true;
			}
			if (this.filterPeakTime.value !== null) {
				return true;
			}
						// if (this.filterDate.startDate || this.filterDate.endDate) {
						//     if (this.filterDate.startDate != "Invalid Date" && this.filterDate.endDate != "Invalid Date") {
						//         return true;
						//     }
						// }
			return false;
		},

		advancedFilterCount() {
					if (!this.$store.getters.userInfo()) {
							return 0;
					}
			let count = 0;
			for (let item in this.arg) {
							if (this.arg[item] != null ) {
								if (item != "completed" && item != "keywords" && item != "closureType" && item != "peakTime"
					&& item != "fromDateTime" && item != "toDateTime" && item != "RequesterOrganizationId"
				) {
					if (item == "requesterProjectId") {
						if (this.arg[item].id != null) {
							count++;
						}
					} else {
							if ( this.$store.state.isMobile) {
								if (item != "showMine") {
									if (item == "affectedStreet") {
										if (this.arg[item] != null) {
											if (this.arg[item].id != null) {
												count++;
											}
										}
									} else {
										count++;
									}
								}
							} else {
								if (item != "sortBy" && item != "sortOrder" && item != "showMine") {
									if (item == "affectedStreet") {
										if (this.arg[item] != null) {
											if (this.arg[item].id != null) {
										count++;
									}
							}
									} else {
										count++;
									}
							}
						}
					}
					}
						}
					}
			if (this.filterMineModel == 1) {
				if ( this.$store.state.isMobile) {
						count++;
					}
				}
			if (this.filterCompleted.value !== 0) {
				count++;
			}
			if (this.filterClosureType.value !== null) {
				count++;
			}
			if (this.filterOrganization.value !== null && this.filterOrganization.value !== undefined) {
					count++;
			}
			if (this.filterPeakTime.value !== null) {
					count++;
			}
			return count;
		},
		handleAutocomplete(value, instanceId) {
			this.setArgs();
		},

		fieldId(name) {
			return "lcr-field-" + name;
		},
		parseLabel(node, argAttr) {
			if (node.label) {
				if (node.label.indexOf('(unknown)') > -1) {
					node.label = this.arg[argAttr]
				} else {
					this.arg[argAttr] = node.label
				}
			}
			return node.label
		},
		toggleAdvancedSearch() {
			this.showUpdates = false;
			this.showMessages = false;
			this.showAdvancedSearch = !this.showAdvancedSearch
			this.saveAdvancedSearch();
		},
		toggleMessages() {
			this.showAdvancedSearch = false;
			this.showUpdates = false;
			this.showMessages = !this.showMessages;
		},
		toggleUpdates() {
			this.showAdvancedSearch = false;
			this.showMessages = false;
			this.showUpdates = !this.showUpdates;
		},
		saveAdvancedSearch() {
			localStorage.setItem('showAdvancedSearch', this.showAdvancedSearch)
		},
		getAdvanceSearchColumnClasses(field) {
			return 'advance-search__' + field;
		},
		getAdvancedSearch() {
			// let testValue = localStorage.getItem('showAdvancedSearch');
			// if (testValue == "true") {
			//     this.showAdvancedSearch = true;
			// } else {
			//     this.showAdvancedSearch = false;
			// }
		},
		getOptionSelected(qty) {
			if (qty == 1) {
				return qty + " option selected";
			} else {
				return qty + " options selected"
			}
		},

		searchGlobal() {
			this.arg['keywords'] = this.globalSearch
			this.setArgs();
			this.$emit('submit:filters')
		},

		toggleCompleted() {
			this.arg['completed'] = this.filterCompleted.value;
		},


		// onAutoCompleteSubmit(result, value, name, keyField) {
		//     this.arg[keyField] = result[value]
		//     this.setArgValues(keyField, result, name)
		//     this.$emit('update:filters', { [keyField]: result[name] })
		// },




		getArgValues(keyField, label) {
			let argQuery = JSON.parse(localStorage.getItem(this.storeFilter))
			if (argQuery == null) {
				argQuery = {};
			}

			if (argQuery != null) {
				if (!Array.isArray(argQuery)) {
					if (argQuery[keyField]) {
						this.arg[keyField] = argQuery[keyField]
					}
				}
				if (!this.arg[keyField]) {
					this.arg[keyField] = {}
					if (label) {
						this.arg[keyField][label] = ''
					}
				}
			}
		},


		clearArgs(filters) {
			this.arg = {
				...this.arg,
				[filters.key]: null,
				[filters.key + '_label']: null
			}
		},
		getArgs(filters) {
			let argQuery = JSON.parse(localStorage.getItem(this.storeArgs))
			if (argQuery == null) {
				argQuery = {};
			}
			// if ( this.arg === undefined )

			if (filters.autoComplete) {
				this.arg = {
					...this.arg,
					[filters.key]: argQuery[filters.key]
				}


			} else if (filters.datePicker) {
				/*
				if (argQuery[filters.datePicker.from] != undefined) this.filterDate.startDate = new Date(argQuery[filters.datePicker.from]);
				if (argQuery[filters.datePicker.to] != undefined) this.filterDate.endDate = new Date(argQuery[filters.datePicker.to]);

				if (argQuery[filters.datePicker.from] == "Invalid date") {
					argQuery[filters.datePicker.from] = null;
					this.filterDate.startDate = null;
				}
				if (argQuery[filters.datePicker.to] == "Invalid date") {
					argQuery[filters.datePicker.to] = null;
					this.filterDate.endDate = null;
				}
				this.arg = {
					...this.arg,
					[filters.datePicker.from]: argQuery[filters.datePicker.from] != undefined ? argQuery[filters.datePicker.from] : null,
					[filters.datePicker.to]: argQuery[filters.datePicker.to] != undefined ? argQuery[filters.datePicker.to] : null,
				}
				*/

				let startMoment = null;
				let endMoment = null;
				if (argQuery[filters.datePicker.from] != undefined) {
					startMoment = this.moment(argQuery[filters.datePicker.from]);
					if (startMoment.isValid()) {
					    startMoment.hours(0);
					    startMoment.minutes(0);
					    startMoment.seconds(0);
						this.arg = {
						    ...this.arg,
						    [filters.datePicker.from]: startMoment.format(),
						}
						this.filterDate.startDate = new Date(startMoment.format());
					} else {
						argQuery[filters.datePicker.from] = null;
						this.arg = {
						    ...this.arg,
						    [filters.datePicker.from]: null,
						}
						this.filterDate.startDate = null;
					}
				}
				if (argQuery[filters.datePicker.to] != undefined) {
					endMoment = this.moment(argQuery[filters.datePicker.to]);
					if (endMoment.isValid()) {
					    endMoment.hours(23);
					    endMoment.minutes(59);
					    endMoment.seconds(59);
					    this.arg = {
					        ...this.arg,
					        [filters.datePicker.to]: endMoment.format(),
					    }
						this.filterDate.endDate = new Date(endMoment.format());
					} else {
						argQuery[filters.datePicker.to] = null;
						this.arg = {
						    ...this.arg,
						    [filters.datePicker.to]: null,
						}
						this.filterDate.endDate = null;
					}
				}



			}
			// pull in the global search and completed request filter.
			if (argQuery != null) {
				if (argQuery.keywords) {
					this.globalSearch = argQuery.keywords;
				} else {
					this.globalSearch = null;
				}
				if (typeof argQuery.completed != "undefined") {
					this.filterCompleted.value = argQuery.completed;
					this.arg["completed"] = argQuery.completed;
				}
				if (typeof argQuery.closureType != "undefined") {
					this.filterClosureType.value = argQuery.closureType;
					this.arg["closureType"] = argQuery.closureType;
				}
				if (typeof argQuery.RequesterOrganizationId != "undefined") {
					this.filterOrganization.value = argQuery.RequesterOrganizationId;
					this.arg["RequesterOrganizationId"] = argQuery.RequesterOrganizationId;
				}
				if (typeof argQuery.peakTime != "undefined") {
					this.filterPeakTime.value = argQuery.peakTime;
					this.arg["peakTime"] = argQuery.peakTime;
				}
				if (argQuery.sortOrder && argQuery.sortBy) {
					this.filterSortBy.value = argQuery.sortBy + " " + argQuery.sortOrder;
					this.arg['sortBy'] = argQuery.sortBy;
					this.arg['sortOrder'] = argQuery.sortOrder;
				}
			} else {
				this.globalSearch = null;
				this.filterCompleted.value = null;
				this.filterClosureType.value = null;
				this.filterOrganization.value = null;
				this.filterPeakTime.value = null;
				this.filterDate = { startDate: null, endDate: null };
				this.filterSortBy.value = '';
			}
			// read in the global filter.
			let globalQuery = JSON.parse(localStorage.getItem("globalFilter"))
			if (globalQuery == null) {
					globalQuery = {};
			}
			if (typeof globalQuery.showMine != "undefined") {
					this.filterMine.value = globalQuery.showMine;
					this.filterMineModel = globalQuery.showMine;
					this.arg["showMine"] = globalQuery.showMine;
			}
			this.getAdvancedSearch();
		},
		setArgs() {
			this.showAdvancedSearch = false;
			localStorage.setItem(this.storeArgs, JSON.stringify(this.arg))
			this.$emit('submit:filters')
		},
		resetArgs() {
			this.arg = Array()
			this.$store.dispatch(this.storeModule + '/clearParams')
			this.columns.map(elem => {
				if (elem.filter != undefined) {
					if (elem.filter.show) {
						this.clearArgs(elem.filter)
					}
				}
			})
			this.filterCompleted.value = 0;
			this.filterClosureType.value = null;
			this.filterOrganization.value = null;
			this.filterPeakTime.value = null;

			let globalQuery = JSON.parse(localStorage.getItem("globalFilter"))
			if (globalQuery != null) {
				if (typeof globalQuery.showMine != "undefined") {
						this.arg["showMine"] = globalQuery.showMine;
						this.filterMine.value = globalQuery.showMine;
				}
			}




			// this.filterDate = { startDate: null, endDate: null };
			this.setArgs();
			this.showAdvancedSearch = false;
			this.saveAdvancedSearch();
			// this.$emit('submit:filters')
		},

		onDatePickerChange(input, keyField) {
			let dateString = null;

				if (input) {
						let theDate = moment.tz({
								year: input.getFullYear(),
								month: input.getMonth(),
								day: input.getDate(),
								hour: keyField == "toDateTime" ? 23 : 0,
								minute: keyField == "toDateTime" ? 59 : 0,
								second: keyField == "toDateTime" ? 59 : 0
						}, Format.TIMEZONE);

			if (theDate.isValid()) {
								dateString = theDate.utc().format();
				}
			}

			this.arg = {
				...this.arg,
				[keyField]: dateString
			}
		},
		onDateRangeSelect(date) {
			const startDate = date.startDate;
			const endDate = date.endDate;

					this.arg = {
							...this.arg,
					fromDateTime: startDate
							? Format.pickerDateToUtc(
									new Date(
											startDate.getFullYear(),
											startDate.getMonth(),
											startDate.getDate(),
											0, 0, 0
									)
								)
							: null,
					toDateTime: endDate
							? Format.pickerDateToUtc(
									new Date(
											endDate.getFullYear(),
											endDate.getMonth(),
											endDate.getDate(),
											23, 59, 59
									)
								)
							: null
			};

			console.log("picker fromDateTime:" + startDate);
			console.log("converted fromDateTime:"+this.arg.fromDateTime);

			console.log("picker endDateTime:" + endDate);
			console.log("converted toDateTime:"+this.arg.toDateTime);


			this.setArgs();
			this.$emit('submit:filters');
		},

		getOrganizationsForTreeSelect() {
			return this.$store.dispatch('organizationList/loadWorkFor', {})
				.then(() => {
					this.organizations = [];
					let result = this.$store.getters['organizationList/getRecords'];
					let refSet = [];
					let cityOrgs = [];
					let thirdPartyOrgs = [];
					let currentLevel = 1;
					let continueLoop = true;

					while (continueLoop) {
						if (currentLevel == 1) {
							let found_first_agency = false;

							result.forEach(x => {
								if (x.level == 1) {
									let o = {
										id: x.id,
										label: x.name,
										organizationTypeId: x.organizationTypeId
									}
									refSet.push(o);

									if (found_first_agency == false) {
										if (x.organizationTypeId == "agency") {
											found_first_agency = true;
											thirdPartyOrgs.push(o);
										} else {
											cityOrgs.push(o);
										}
									} else {
										thirdPartyOrgs.push(o);
									}
								}
							});
						} else {
							let newRef = [];
							result.forEach(x => {
								if (x.level == currentLevel) {
									let org = {
										id: x.id,
										label: x.name,
										parentId: x.parentId,
										organizationTypeId: x.organizationTypeId
									};

									newRef.push(org);
								}
							});

							newRef.forEach(x => {
								refSet.forEach(y => {
									if (x.parentId == y.id) {
										if (y.children == undefined) y.children = [];
										y.children.push(x);
									}
								});
							});

							refSet = newRef;
						}
						currentLevel++;
						if (refSet.length == 0) {
							continueLoop = false;
						}
					}
					this.organizations = [...cityOrgs, ...thirdPartyOrgs];
				});
		},

		onAffectedStreetInput(value, instance) {},
		onAffectedStreetSearch(input) {
			const index = 0;
			if (input != '') {
				this.isAffectedStreetsLoading = true;
				this.$store.dispatch(this.columns[index]['filter']['autoComplete']['search'], input)
					.then(res => {
						this.affectedStreetOptions = [];
						var item = {
							id: null,
							label: "Any Street",
						}
						this.affectedStreetOptions.push(item);

						for (var x = 0; x < res.length; x++) {
							item = {
								id: `${res[x][this.columns[index]['filter']['autoComplete'].name]}`,
								label: `${res[x][this.columns[index]['filter']['autoComplete'].label]}`,
							}
							this.affectedStreetOptions.push(item);
						}
						this.isAffectedStreetsLoading = false;

					})
			}
		},

		onRequesterProjectInput(filter) {},
		onRequesterProjectSearch(input) {
			var item = {};
			const index = 4; // 4th colum nin LaneClosureListModule...
			this.isRequesterProjectLoading = true;
			this.$store.dispatch(this.columns[index]['filter']['autoComplete']['search'], input)
				.then(res => {
					this.requesterProjectOptions = [];
					item = {
						id: null,
						label: "Any Project",
					}
					this.requesterProjectOptions.push(item);

					for (var x = 0; x < res.length; x++) {
						item = {
							id: `${res[x][this.columns[index]['filter']['autoComplete'].name]}`,
							label: `${res[x][this.columns[index]['filter']['autoComplete'].label]} (${res[x][this.columns[index]['filter']['autoComplete'].organizationName]})`,
						}
						this.requesterProjectOptions.push(item);
					}
					this.isRequesterProjectLoading = false;

				})
		},



		loadOptions1({ action, searchQuery, callback }) {
			if (action === ASYNC_SEARCH) {
				const index = 4
				if (this.columns[index]['filter']['autoComplete'] != undefined && searchQuery.length > 0) {
					this.$store.dispatch(this.columns[index]['filter']['autoComplete']['search'], searchQuery)
						.then(res => {
							const options = res.map(item => ({
								id: `${item[this.columns[index]['filter']['autoComplete'].name]}`,
								label: `${item[this.columns[index]['filter']['autoComplete'].label]}`,
							}))
							// .filter(i => i.label.toUpperCase().indexOf(searchQuery.toUpperCase()) > -1 )
							callback(null, options)
						})
				}
			}
		},
		loadOptions2({ action, searchQuery, callback }) {
			if (action === ASYNC_SEARCH) {
				const index = 0
				if (this.columns[index]['filter']) {
					if (this.columns[index]['filter']['autoComplete'] != undefined && searchQuery.length > 0) {
						this.$store.dispatch(this.columns[index]['filter']['autoComplete']['search'], searchQuery)
							.then(res => {
								const options = res.map(item => ({
										id: `${item[this.columns[index]['filter']['autoComplete'].name]}`,
										label: `${item[this.columns[index]['filter']['autoComplete'].label]}`,
									}))
									.filter(i => i.label.toUpperCase().indexOf(searchQuery.toUpperCase()) > -1)
								callback(null, options)
							})
					}
				}
			}
		},
		toggleMenu() {
			Vue.prototype.$bus.$emit('menu:toggle', null);
		},
		toggleMine() {
			this.arg['showMine'] = this.filterMine.value;
			Vue.prototype.$bus.$emit("filter:toggleMine", this.filterMine.value);
		},
		onOrganizationInput(input) {
			this.arg['RequesterOrganizationId'] = this.filterOrganization.value;
		},
		toggleClosureType() {
			this.arg['closureType'] = this.filterClosureType.value;
		},
		togglePeakTime() {
			this.arg['peakTime'] = this.filterPeakTime.value;
		},

		clearSearch() {
			this.globalSearch = null;
			this.filterDate = {
				startDate: null,
				endDate: null,
			};
			this.arg['fromDateTime'] = null;
			this.arg['toDateTime'] = null;
			this.searchGlobal();
		},

	}
}
</script>